import { EventGraphBase, EventGraphNode, EventGraphNodeRender, EventHandlerCmdEnd, EventHandlerEditPri, EventHandlerGeneratePri, EventHandlerGrid, EventHandlerStart, EventHandlerUpdateAndDeletePri, UpdateType } from "pytha2";
import { EventHandlerAlignAxisNet } from "../event-handler/EHAlignAxisNet";

/**
 * 对齐轴网图
 */
export class EventGraphAlignAxisNet extends EventGraphBase {

    /**
     * align_axis_net指令，对齐轴网
     */
    static cmd: string = "ALIGNAXISNET"

    generate(): void {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerAlignAxisNet);
        const node3 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node4 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNode(this, EventHandlerUpdateAndDeletePri);

        this.addEdge(node1, node2);
        this.addEdge(node4, node3);
        this.addEdge(node5, node4);
        this.addEdge(node2, node6);
        this.addEdge(node6, node5);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/131
    }
}